import { Outlet } from "react-router-dom";
import Sidebar from '../../Client/Components/Sidebar.jsx'
import { useState } from "react";

const Layout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(true);

    const contentStyle = {
        marginLeft: sidebarOpen ? "240px" : "70px",
        transition: "0.3s",
    };

    return (
        <div>
            <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />

            <div style={contentStyle}>
                <Outlet />   {/* your page content */}
            </div>
        </div>
    );
};

export default Layout;
